import http from '@/utils/http';
import i18n from '@/main';

export default {
    consultar(tipo, documento, idOperacao, idsProdutos) {
        return http.post({
            url: `/diagnostico-socioambiental/buscar/${tipo}/${documento}/operacao?idOperacao=${idOperacao ?? ''}&idsProdutos=${idsProdutos ?? ''}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoDiagnosticoSocioambiental')
        });
    }
};
